import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@material-ui/core";
import Form from "../form";
import Menu from "../menu";
import Recommender from "../recommender";
import WheelFortune from "../wheel-fortune";
import { loadScript, isDev } from "../common";

const Preview = () => {
  const { view } = useParams();
  useEffect(() => {
    if (view == "menu") {
      loadScript(
        "ezcaScript",
        isDev()
          ? "http://cors.com/js/sdk.js"
          : "https://cdn.ezca.asia/js/sdk.js",
        () => {}
      );
    }
  }, []);
  //console.log(view);
  return (
    <Box>
      {view == "form" && <Form />}
      {view == "menu" && <Menu isPreview={true} />}
      {view == "recommender" && <Recommender />}
      {view == "wheel-fortune" && <WheelFortune />}
    </Box>
  );
};
export default Preview;
